const keyPrefix = 'map2__';

export function setLocalStorageItem<T>(key: string, value: T) {
    localStorage.setItem(keyPrefix + key, JSON.stringify(value));
}

export function getLocalStorageItem<T>(
    key: string,
    defaultValue: T,
    validator: (t: T) => boolean = () => true
): T {
    const jsonValue = localStorage.getItem(keyPrefix + key);
    if (jsonValue === null || jsonValue === 'undefined') {
        return defaultValue;
    } else {
        try {
            const value = JSON.parse(jsonValue) as T;
            return validator(value) ? value : defaultValue;
        } catch (error) {
            console.error(error, jsonValue);
            return defaultValue;
        }
    }
}
